// @flow
import styled from 'styled-components'

const Super = styled.sup`
  display: inline-block;
  vertical-align: middle;
  top: 0;
`

export default Super



// WEBPACK FOOTER //
// ./src/components/typography/super.js